import { filesApi } from './axios';

// API для работы с файлами через file_service
export const getFileInfo = async (fileUid) => {
  const response = await filesApi.get(`/${fileUid}`);
  return response.data;
};

export const getFileDownloadUrl = async (fileUid) => {
  const response = await filesApi.get(`/${fileUid}/download`);
  return response.data;
};

export const downloadFile = async (fileUid, filename) => {
  try {
    // Получаем URL для скачивания
    const urlResponse = await filesApi.get(`/${fileUid}/download`);
    const downloadUrl = urlResponse.data.download_url;
    
    // Создаем ссылку для скачивания
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename || 'file');
    link.setAttribute('target', '_blank'); // Открываем в новой вкладке для безопасности
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    return { success: true, url: downloadUrl };
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
};

// Скачивание через прокси file_service: GET /api/files/{uid}/content (axios передаёт Bearer)
export const downloadFileBlob = async (fileUid, filename) => {
  try {
    const response = await filesApi.get(`/${fileUid}/content`, { responseType: 'blob' });
    const blob = response.data;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename || 'file');
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return blob;
  } catch (error) {
    console.error('Error downloading file blob:', error);
    throw error;
  }
};

export const uploadFile = async (file, metadata = {}) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('metadata', JSON.stringify(metadata));

  const response = await filesApi.post('/upload/direct', formData);
  return response.data;
};

export const getFilesByEntity = async (entityType, entityUid, skip = 0, limit = 100) => {
  const metadata = JSON.stringify({
    entity_type: entityType,
    entity_uid: entityUid,
  });
  const response = await filesApi.get('/', {
    params: { metadata, skip, limit },
  });
  return response.data;
};

export default {
  getFileInfo,
  getFileDownloadUrl,
  downloadFile,
  downloadFileBlob,
  uploadFile,
  getFilesByEntity
}; 